import { useState } from "react";
import App from "../App";
import AuthTokenSetter from "./AuthTokenSetter";

function AuthGate() {
  const [tokenReady, setTokenReady] = useState(false);

  return !tokenReady
    ? <AuthTokenSetter onReady={() => setTokenReady(true)} />
    : <App />;
}

export default AuthGate;